export function getPageFromPages(pages, treeIndex) {
    if (pages.length === 0) return null;
    const indexes = treeIndex.split("_").map(index => parseInt(index));
    const page = pages[indexes[0]].items[indexes[1]];
    return page;
}

export function checkDuplicatePageName(pages, pageName) {
    return pages.some(page => page.pageName.trim().toLowerCase() === pageName.trim().toLowerCase());
}

export function getFlatPages(portalFolders) {
    const flatPages = portalFolders.map(portalFolder => portalFolder.items).flat();
    return flatPages;
}

export function getHighestPageOrder(pages) {
    let highestOrder = 0;
    pages.forEach(page => {
        const order = parseInt(page.order)
        if (order > highestOrder) {
            highestOrder = order;
        }
    });
    return highestOrder;
}

export function getPageByProperty(pages, property, value) {
    for (const page of pages) {
        if (page.items && page.items.length > 0) {
            const foundPage = getPageByProperty(page.items, property, value);
            if (foundPage) {
                return foundPage;
            }
        }
        if (page[property] === value) {
            return page;
        }
    }
    return null;
}

export function getPagesOfPortal(portalId, pages) {
    const portalPages = [];
    for (const folder of pages) {
        if (folder.items && folder.items.length > 0) {
            for (const page of folder.items) {
                if (page.portalId === portalId) {
                    portalPages.push(page);
                }
            }
        }
    }
    return portalPages;
}

export function bySystemAttributeDesc(a, b) {
    if (a.isSystemAttribute && !b.isSystemAttribute) {
        return 1;
    }
    if (!a.isSystemAttribute && b.isSystemAttribute) {
        return -1;
    }
    return 0;
}

export function byOrder(a, b) { return a.order - b.order; }

export function byAttributeName(a, b) {
    return a.attributeName.localeCompare(b.attributeName);
}

export function isLanguagesChanged(languages, defaultLanguages) {
    const keys = Object.keys(languages);
    for (const key of keys) {
        if (
            languages[key].label !== defaultLanguages[key].label ||
            languages[key].tooltip !== defaultLanguages[key].tooltip
        ) {
            return true;
        }
    }
    return false;
}